import comp from "./UIBaseComponent";
export default comp;
